// Klik w nazwe kolekcji na kafelku produktu (span .js-collection-link wewnatrz
// linku kafelka) nawiguje do strony kolekcji zamiast do produktu.
// Jedna delegacja na document zamiast inline <script> per kafelek - dziala
// tez dla kafelkow doladowanych AJAX-em przy filtrowaniu listingu.
document.addEventListener('click', (e) => {
    const link = e.target.closest('.js-collection-link');

    if (!link || !link.dataset.collectionUrl) return;

    e.preventDefault();
    e.stopPropagation();

    window.location.href = link.dataset.collectionUrl;
});
